(function() {
  'use strict';

  angular
    .module('mgpCorregedoriaApp.validacao')
    .constant('CONSTANTS', {
      QUANTIDADE_MAXIMA_MEMBRO_RELATORIO_CONCURSO: 15, //Quantidade maxima permitida de inclusao de membros no relatorio de concurso
      QUANTIDADE_MAXIMA_ORGAO_RELATORIO_ORGAO: 15,       //Quantidade maxima permitida de inclusao de orgao no relatorio de orgao
      ANO_INICIO_ANUARIO:2017 //Ano inicial do relatorio anuario
    });
})();
